var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "hotel-list-search-bar",
      attrs: { "data-component": "hotel-list-search-bar" },
    },
    [
      _c("input", {
        staticClass: "search-input icon-search",
        attrs: {
          placeholder: _vm.tc("booking.findYourDestination"),
          value: "",
        },
        on: { input: _vm.triggerFilter },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }